import { Box, ColorsV2, getToken, spaces, Text } from '@electricjs/arc';
import { DeviceRetrieveAction } from './types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const StyledUnorderedList = styled.ul`
  font-size: 1.6rem;
  padding-left: 2.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0;
`;

const StyledListItem = styled.li`
  color: ${getToken(ColorsV2.TEXT)};
  margin-bottom: 0.5rem;
`;

type DeviceRetrievalPolicyProps = {
  deviceRetrieveAction: DeviceRetrieveAction;
  isInternationalFlow: boolean;
};

const DeviceRetrievalPolicy = ({
  deviceRetrieveAction,
  isInternationalFlow,
}: DeviceRetrievalPolicyProps) => {
  const { t } = useTranslation('common');

  return (
    <Box mt={spaces.space_l_rem}>
      {deviceRetrieveAction === DeviceRetrieveAction.Warehouse && (
        <Box>
          <Text variant="body" mb="1rem">
            {t('offboardings.deviceRetrievalPolicy.warehousing.title')}
          </Text>
          <StyledUnorderedList>
            {!isInternationalFlow && (
              <StyledListItem>
                {t('offboardings.deviceRetrievalPolicy.warehousing.item1')}
              </StyledListItem>
            )}
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.warehousing.item2')}
            </StyledListItem>
            {!isInternationalFlow && (
              <StyledListItem>
                {t('offboardings.deviceRetrievalPolicy.warehousing.item3')}
              </StyledListItem>
            )}
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.warehousing.item4')}
            </StyledListItem>
          </StyledUnorderedList>
        </Box>
      )}
      {deviceRetrieveAction === DeviceRetrieveAction.Ship && (
        <Box>
          <Text variant="body" mb="1rem">
            {t('offboardings.deviceRetrievalPolicy.shipping.title')}
          </Text>
          <StyledUnorderedList>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.shipping.item1')}
            </StyledListItem>
            {!isInternationalFlow && (
              <StyledListItem>
                {t('offboardings.deviceRetrievalPolicy.shipping.item2')}
              </StyledListItem>
            )}
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.shipping.item3')}
            </StyledListItem>
          </StyledUnorderedList>
        </Box>
      )}
      {deviceRetrieveAction === DeviceRetrieveAction.InPerson && (
        <Box>
          <Text variant="body" mb="1rem">
            {t('offboardings.deviceRetrievalPolicy.inPerson.title')}
          </Text>
          <StyledUnorderedList>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.inPerson.item1')}
            </StyledListItem>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.inPerson.item2')}
            </StyledListItem>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.inPerson.item3')}
            </StyledListItem>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.inPerson.item4')}
            </StyledListItem>
          </StyledUnorderedList>
        </Box>
      )}
      {deviceRetrieveAction === DeviceRetrieveAction.Keep && (
        <Box>
          <Text variant="body" mb="1rem">
            {t('offboardings.deviceRetrievalPolicy.keep.title')}
          </Text>
          <StyledUnorderedList>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.keep.item1')}
            </StyledListItem>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.keep.item2')}
            </StyledListItem>
            <StyledListItem>
              {t('offboardings.deviceRetrievalPolicy.keep.item3')}
            </StyledListItem>
          </StyledUnorderedList>
        </Box>
      )}
    </Box>
  );
};

export default DeviceRetrievalPolicy;
